// extracted by mini-css-extract-plugin
export default {"input":"bia-z","button":"cia-z","selected":"dia-z","sephoraImage":"eia-z","unavailable":"fia-z","image":"gia-z"};